<template>
    <div :id="anim" class="Capacity">
        <h4>{{msg}}</h4>
        <ul>
            <li v-for="(detail, i) in details" :key="i">+ {{detail}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Capacity',
    props: {
        msg: String,
        details: Array,
        anim:String
    },
    mounted() {
        const animUX = this.$scrollmagic.scene({
          triggerElement: '#triggerCapacity0',
          duration: 500
        })
        .setTween( "#animCapacity0", 0.5, {opacity:1, left:'0px'})
        // .addIndicators({ name: 'Anim capacity 0 (duration: 500)' })

        const animWeb = this.$scrollmagic.scene({
          triggerElement: '#triggerCapacity1',
          duration: 500
        })
        .setTween( "#animCapacity1", 0.5, {opacity:1, left:'0px'})
        // .addIndicators({ name: 'Anim capacity 1 (duration: 500)' })

        const animMob = this.$scrollmagic.scene({
          triggerElement: '#triggerCapacity2',
          duration: 500
        })
        .setTween( "#animCapacity2", 0.5, {opacity:1, left:'0px'})
        // .addIndicators({ name: 'Anim capacity 2 (duration: 500)' })

        const animMkt = this.$scrollmagic.scene({
          triggerElement: '#triggerCapacity3',
          duration: 500
        })
        .setTween( "#animCapacity3", 0.5, {opacity:1, left:'0px'})
        // .addIndicators({ name: 'Anim capacity 3 (duration: 500)' })
      
        this.$scrollmagic.addScene([animUX, animWeb, animMob, animMkt])
    }
}
</script> 

<style scoped lang="scss">
@import '@/assets/style/learning.scss';
</style>